import useStorage from "@/hooks/use-storage";

const PRINT_BOLD_STORAGE_KEY = "printBold";

export default function usePrintBold() {
    return useStorage<boolean>(PRINT_BOLD_STORAGE_KEY, "local", false);
}
